export enum EmailStatus {
	Pending = 10,
	Processing = 15,
	Sent = 20,
	Failed = 0
}